import { render, staticRenderFns } from "./postArticles.vue?vue&type=template&id=7be7fb4b&scoped=true&"
import script from "./postArticles.vue?vue&type=script&lang=js&"
export * from "./postArticles.vue?vue&type=script&lang=js&"
import style0 from "./postArticles.vue?vue&type=style&index=0&id=7be7fb4b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be7fb4b",
  null
  
)

export default component.exports